import {type ComponentProps} from 'react';
import {connect} from 'react-redux';

import {getCurrentTeamId, getCurrentRelativeTeamUrl} from 'mattermost-redux/selectors/entities/teams';
import {getCurrentUserId} from 'mattermost-redux/selectors/entities/users';
import {type GlobalState} from 'types/store';
import {
    setRhsExpanded,
    showSearchResults,
    showFlaggedPosts,
    showPinnedPosts,
    showChannelFiles,
    closeRightHandSide,
    toggleRhsExpanded,
    goBack,
} from 'actions/views/rhs';
import {getIsRhsExpanded} from 'selectors/rhs';
import {getIsMobileView} from 'selectors/views/browser';

import {changeThreadFollowOnServer} from 'features/threads/actions/change_thread_follow_on_server';
import {getThreadPostFollowState} from 'features/threads/selectors/get_thread_post_follow_state';
import {type ThreadHeaderPluginComponent} from 'types/store/plugins';

import RhsHeaderPost from './rhs_header_post';

type OwnProps = Pick<ComponentProps<typeof RhsHeaderPost>, 'rootPostId'>;

const mapThreadHeaderPluginItems = (pluginItems: ThreadHeaderPluginComponent) => ({
    key: `plugin-button-${pluginItems.id}`,
    icon: pluginItems.icon,
    onPress: () => pluginItems.action?.(pluginItems.id),
    tooltipText: pluginItems?.tooltipText,
    tooltipNode: pluginItems?.tooltipNode,
});

export type PluginItem = ReturnType<typeof mapThreadHeaderPluginItems>;

function mapStateToProps(state: GlobalState, {rootPostId}: OwnProps) {
    const isFollowingThread = getThreadPostFollowState(state, rootPostId);

    const currentUserId = getCurrentUserId(state);

    return {
        isExpanded: getIsRhsExpanded(state),
        isMobileView: getIsMobileView(state),
        relativeTeamUrl: getCurrentRelativeTeamUrl(state),
        currentTeamId: getCurrentTeamId(state),
        currentUserId,
        isFollowingThread,
        pluginItems: state.plugins.components.ThreadHeaderItem.map(mapThreadHeaderPluginItems),
    };
}

const actions = {
    setRhsExpanded,
    showSearchResults,
    showFlaggedPosts,
    showPinnedPosts,
    showChannelFiles,
    closeRightHandSide,
    toggleRhsExpanded,
    changeThreadFollowOnServer,
    goBack,
};

export default connect(mapStateToProps, actions)(RhsHeaderPost);
